export default class UnsplashImage {
	constructor({
		id,
		alt_description: alt,
		urls,
		links,
		user,
		width,
		height
	} = {}) {
		this._id = id;
		this._alt = alt;
		this._width = width;
		this._height = height;
		this._urls = urls || {};
		this._links = links || {};
		this._user = user || { links: {} };
	}

	getId() {
		return this._id;
	}

	getKey() {
		return String(this._id);
	}

	getAlt() {
		return this._alt;
	}

	getThumbnail() {
		return this._urls.thumb || null;
	}

	getImageLink() {
		return this._urls.regular || null;
	}

	getCreditLink() {
		return this._user.links.html || null;
	}

	getCreditUsername() {
		return this._user.username || null;
	}

	getDownloadLocation() {
		return this._links.download_location || null;
	}

	getWidth() {
		return this._width;
	}

	getHeight() {
		return this._height;
	}
}
